// Recovered compiled webpack factory 7916. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n, a, o;
  r.d(t, { i: () => c });
  var i = r(21010),
    s = r(73314),
    l = r(28385),
    u = r(38599);
  function c(e) {
    ((0, i.s5)("dom", e), (0, i.AS)("dom", f));
  }
  function f() {
    if (!u.j.document) return;
    let e = i.aj.bind(null, "dom"),
      t = d(e, !0);
    (u.j.document.addEventListener("click", t, !1),
      u.j.document.addEventListener("keypress", t, !1),
      ["EventTarget", "Node"].forEach((t) => {
        let r = u.j,
          n = r[t]?.prototype;
        n?.hasOwnProperty?.("addEventListener") &&
          ((0, s.GS)(n, "addEventListener", function (t) {
            return function (r, n, a) {
              if ("click" === r || "keypress" == r)
                try {
                  let n = (this.__sentry_instrumentation_handlers__ =
                      this.__sentry_instrumentation_handlers__ || {}),
                    o = (n[r] = n[r] || { refCount: 0 });
                  if (!o.handler) {
                    let n = d(e);
                    ((o.handler = n), t.call(this, r, n, a));
                  }
                  o.refCount++;
                } catch {}
              return t.call(this, r, n, a);
            };
          }),
          (0, s.GS)(n, "removeEventListener", function (e) {
            return function (t, r, n) {
              if ("click" === t || "keypress" == t)
                try {
                  let r = this.__sentry_instrumentation_handlers__ || {},
                    a = r[t];
                  a &&
                    (a.refCount--,
                    a.refCount <= 0 &&
                      (e.call(this, t, a.handler, n), (a.handler = void 0), delete r[t]),
                    0 === Object.keys(r).length && delete this.__sentry_instrumentation_handlers__);
                } catch {}
              return e.call(this, t, r, n);
            };
          }));
      }));
  }
  function d(e, t = !1) {
    return (r) => {
      var i;
      if (!r || r._sentryCaptured) return;
      let c = (function (e) {
        try {
          return e.target;
        } catch {
          return null;
        }
      })(r);
      if (
        ((i = r.type),
        "keypress" === i &&
          (!c?.tagName ||
            ("INPUT" !== c.tagName && "TEXTAREA" !== c.tagName && !c.isContentEditable && 1)))
      )
        return;
      ((0, s.my)(r, "_sentryCaptured", !0),
        c && !c._sentryId && (0, s.my)(c, "_sentryId", (0, l.eJ)()));
      let f = "keypress" === r.type ? "input" : r.type;
      (!(function (e) {
        if (e.type !== a) return !1;
        try {
          if (!e.target || e.target._sentryId !== o) return !1;
        } catch {}
        return !0;
      })(r) && (e({ event: r, name: f, global: t }), (a = r.type), (o = c ? c._sentryId : void 0)),
        clearTimeout(n),
        (n = u.j.setTimeout(() => {
          ((o = void 0), (a = void 0));
        }, 1e3)));
    };
  }
}
